import { decodeBase64 } from '@root/_utils';
import React from 'react';
/**
 * Return the custom CSS element
 * @returns {React.Element}
 */
const CustomCSSElement = ({
  settings,
  preview
}) => {
  if (preview === false && settings?.global?.appearance?.custom_css && settings?.global?.appearance?.custom_css !== "") {
    return (
      <style dangerouslySetInnerHTML={{__html: decodeBase64(settings.global.appearance.custom_css) }} />
    )
  }
  return <></>;
};

export default CustomCSSElement;